export { default } from './ScrollToPrevious';


// WEBPACK FOOTER //
// ./src/components/ScrollToPrevious/index.js